const termsOfService = [
    {
        id: "overview",
        title: "1. Overview",
        content: "Welcome to AS Designs Galaxy. By accessing and purchasing from our website, you agree to comply with and be bound by these Terms of Service. These terms apply to all users, customers, and visitors of our website."
    },
    {
        id: "products",
        title: "2. Digital Products",
        content: "We sell digital products including HTML and React website templates. All products are delivered electronically and no physical items will be shipped."
    },
    {
        id: "license",
        title: "3. License & Usage",
        content: "When you purchase a template, you are granted a non-exclusive, non-transferable license to use the product. You may use the template for personal or commercial projects, but you may not resell, redistribute, or share the original files."
    },
    {
        id: "payments",
        title: "4. Payments",
        content: "All payments are securely processed through Lemon Squeezy. By completing a purchase, you agree to provide accurate billing information and authorize the payment."
    },
    {
        id: "refunds",
        title: "5. Refund Policy",
        content: "All purchases are subject to our Refund Policy. Due to the nature of digital products, refunds are only provided in limited cases such as non-delivery or major defects."
    },
    {
        id: "support",
        title: "6. Support",
        content: "We provide basic support for our templates, including installation guidance and assistance with minor issues. Support does not include extensive customization or third-party integrations."
    },
    {
        id: "user-responsibility",
        title: "7. User Responsibilities",
        content: "You agree to use our products lawfully and responsibly. You are responsible for ensuring that you have the necessary technical knowledge to use and customize the templates."
    },
    {
        id: "limitations",
        title: "8. Limitation of Liability",
        content: "We are not liable for any direct, indirect, or incidental damages resulting from the use or inability to use our products. All templates are provided 'as is' without warranties of any kind."
    },
    {
        id: "third-party",
        title: "9. Third-Party Services",
        content: "Our templates may integrate with third-party tools or services. We are not responsible for the functionality or policies of these external services."
    },
    {
        id: "termination",
        title: "10. Termination",
        content: "We reserve the right to terminate or restrict access to our website or services at any time if users violate these terms."
    },
    {
        id: "updates",
        title: "11. Changes to Terms",
        content: "We may update these Terms of Service at any time. Continued use of the website after changes means you accept the updated terms."
    },
    {
        id: "contact",
        title: "12. Contact Information",
        content: "If you have any questions regarding these Terms, please contact us at asdesigns632@gmail.com."
    }
];

export default termsOfService;